const noop = $.noop;

export default {
    start: noop,
    setComplate: noop,
    setCancel: noop,
};
